var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 30,
    viewBox: "0 0 12 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".MenuClose{fill:#fff;stroke:#0084d0;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12002 -17810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H8a4,4,0,0,1,4,4V26a4,4,0,0,1-4,4H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(-12002 17810)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuClose",
    d: "M7.776.221a.759.759,0,0,0-1.07,0L3.981,2.907,1.295.221A.759.759,0,1,0,.224,1.3L3.442,4.516a.759.759,0,0,0,1.078,0L7.776,1.3a.759.759,0,0,0,0-1.078Z",
    transform: "translate(-11992.506 17821.541) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuClose",
    d: "M7.776.221a.759.759,0,0,0-1.07,0L3.981,2.907,1.295.221A.759.759,0,1,0,.224,1.3L3.442,4.516a.759.759,0,0,0,1.078,0L7.776,1.3a.759.759,0,0,0,0-1.078Z",
    transform: "translate(-11995.185 17821.541) rotate(90)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/MenuClose.dc0505fe4d4888df9f802ca779ac9fd7.svg";
export { ForwardRef as ReactComponent };